<template>
  <div class="prviwetop" :class="[ show ? 'min-show' : 'min-hide' ]">
    <div class="prviwe" v-if="show">
      <img src="../assets/icon/imgleft.png" alt="" class="imgleft" @click="leftClick">
      <img class="blick" src="../assets/icon/blick.png" alt="" @click.stop="hidefn">
      <img class="leftrotating" src="../assets/icon/left-rotate.png" alt="左旋转" title="左旋转" @click="leftRotatClick">
      <img class="rightrotating" src="../assets/icon/right-rotate.png" title="右旋转" alt="右旋转" @click="rightRotatClick">
      <div v-if="picImages[index]">
        <div class="imgbox" id="imgbox" v-drag @mousewheel.prevent="rollImg">
          <img class="imgsrc" :src="picImages[index].ImageUrlPath" ref="imgbox" @dragstart="handleDragstart" alt="" :style="[ {transform: ` rotate(${ rotateNumber }deg)`}]">
        </div>
      </div>
      <img src="../assets/icon/imgright.png" alt="" class="imgright" @click="rigthClick">
    </div>
    <!--  -->
  </div>
</template>

<script>
import config from '../config/confighttp'
export default {
  props: {
    // 是否显示图片预览
    show: {
      type: Boolean,
      default: false
    },
    picImages: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      imgsrc: '',
      index: 0,
      rotateNumber: 0,//旋转角度
      // imgData: [
      //   { imagePath: require('../static/1.jpg') },
      //   { imagePath: require('../static/2.jpg') },
      //   { imagePath: require('../static/3.png')}
      // ]
    }
  },
  created() {

  },
  directives: {
    drag: {
      // 指令的定义
      bind: function (el) {
        // 获取当前元素
        let oDiv = el;
        oDiv.onmousedown = (e) => {
          // 算出鼠标相对元素的位置
          let disX = e.clientX - oDiv.offsetLeft;
          let disY = e.clientY - oDiv.offsetTop;

          document.onmousemove = (e) => {
            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            let left = e.clientX - disX;
            let top = e.clientY - disY;

            oDiv.style.left = left + 'px';
            oDiv.style.top = top + 'px';
          };
          document.onmouseup = () => {
            document.onmousemove = null;
            document.onmouseup = null;
          }
        }
      }
    }
  },
  mounted() {
    this.config = JSON.parse(JSON.stringify(config))
  },
  methods: {
    handleDragstart() {
      console.log('dragstart');
    },
    // 滚动放大
    rollImg(event) {
      
      /* 获取当前页面的缩放比 若未设置zoom缩放比，则为默认100%，即1，原图大小 */
      var zoom = parseInt(this.$refs.imgbox.style.zoom) || 90;
      
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动 */
      zoom += event.wheelDelta / 12;
   
      /* 最小范围 和 最大范围 的图片缩放尺度 */
      if (zoom >= 90 && zoom < 100000) {
        this.$refs.imgbox.style.zoom = zoom + "%";
        console.log( this.$refs.imgbox.style.zoom);
      }
      return false;
    },
    hidefn() {
      this.index = 0
      this.$emit('hidefn')
    },
    leftClick() {
      if (this.index >= 1) {
        this.index--
      } else {
        this.index = this.picImages.length - 1
      }
    },
    rigthClick() {
      if (this.index < this.picImages.length - 1) {
        this.index++
      } else {
        this.index = 0
      }
    },
    // 右旋转
    rightRotatClick() {
      this.rotateNumber += 90
    },
    // 左旋转
    leftRotatClick() {
      this.rotateNumber -= 90
    },
  }
}
</script>
<style scoped lang="less">
.prviwetop {
  .imgbox {
    // background-color: red;
    height: 600px;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .blick {
    position: absolute;
    right: 100px;
    top: 50px;
    width: 20px;
    height: 20px;

    pointer-events: pointer;
    z-index: 9999999;
    cursor: pointer;
  }
}
&.min-show {
  background-color: rgba(0, 0, 0, 0.521);
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 9999999;
  transition: all linear 0.2s;
}
&.min-hide {
  // background-color: black;
  //  visibility: hidden;
  transition: all 0.3s;
}
.active {
  z-index: 10;
  animation: show 0.6s linear forwards;
}
.prviwe {
  //   background-color: black;
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 9999999;
  display: flex;
  justify-content: space-around;
  align-items: center;

  .imgsrc {
    // width: 900px;
    height: 766px;
    border-radius: 5px;
    transition: all 0.3s;
  }
}
.bg {
  background-color: black;
  opacity: 0.2;
  width: 500px;
  height: 500px;
  z-index: 9999999;
}
.imgleft {
  width: 32px;
  height: 32px;
  position: relative;
  // left: -400px;
  z-index: 9999;
  cursor: pointer;
}
.imgright {
  width: 32px;
  height: 32px;
  position: relative;
  // left: 400px;
  // border: 1px solid red;
  z-index: 9999;
  cursor: pointer;
}
.leftrotating {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 150px;
  top: 50px;
  pointer-events: pointer;
  cursor: pointer;
}
.rightrotating {
  position: absolute;
  width: 20px;
  height: 20px;
  right: 125px;
  top: 50px;
  pointer-events: pointer;
  cursor: pointer;
}
</style>
